import { CardFacadeBase } from 'utils/facades/card-facade-base';

class SandboxFacade extends CardFacadeBase {}

export { SandboxFacade };
